(function () {
  'use strict';

  angular
    .module('MktzapApp.Factories')
    .factory('JobsWorkerService', JobsWorkerService);

  JobsWorkerService.$inject = ['$resource'];

 	function JobsWorkerService ($resource) {
    return $resource('', {}, {
      all: { url: apiUrl + '/jobs/workers/all', method: 'GET', params: {}, isArray: true },
      create: { url: apiUrl + '/jobs/workers/create', method: 'POST', params: {}, isArray: false },
      update: { url: apiUrl + '/jobs/workers/update', method: 'POST', params: {}, isArray: false },
      delete: { url: apiUrl + '/jobs/workers/delete/:id', method: 'DELETE', params: {}, isArray: false }
    });
  }
})();
